import { FluidOwaSource, isChapterTwoSource } from 'owa-fluid-validations';
import getStore from '../store/store';
import { isCollabSpaceReadEnabled } from 'owa-calendar-collab-space-validations';

export function isFluidOwaSourceValidForPerfScenario(owaSource: FluidOwaSource | null) {
    return (
        isCollabSpaceReadEnabled() &&
        getStore().fluidOwaSource === owaSource &&
        isChapterTwoSource(owaSource)
    );
}
